import React from 'react';
import PropTypes from 'prop-types'

import css from './TextInput.module.scss'

const TextInput = ({placeholder, value, changeHandler, disableAutocorrect = false}) => {
  const autocorrect = disableAutocorrect ? "off" : "on"
  return (
    <div className={css.form}>
      <input
        type="text"
        className={css.input}
        value={value}
        onChange={changeHandler}
        required
        autocorrect={autocorrect}
        autocapitalize={autocorrect} 
      />
      <label className={css.label}>
        <span className={css.contentName}>{placeholder}</span>
      </label>
    </div>
  )
}

TextInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  changeHandler: PropTypes.func.isRequired
}

TextInput.defaultProps = {
  placeholder: '',
  value: ''
}

export default TextInput;
